import styled from "styled-components";

const IbanInputWrapper = styled.div`
  display: flex;
  .prefix {
    justify-content: center;
    align-items: center;
    display: flex;
    color: #6b47f5;
    border: 1px solid #ced4da;
    border-right: none;
    padding: 7px;
    font-weight: bold;
    font-family: "Bliss2";
  }
  .prefix-stc {
    justify-content: center;
    align-items: center;
    display: flex;
    color: #4f008c;
    border: 1px solid #ced4da;
    border-right: none;
    padding: 7px;
    font-weight: bold;
    font-family: "Bliss2";
  }
`;

export default IbanInputWrapper;
